const t = (e) => e, c = (e) => Object.entries(e);
export {
  t as createEnumObject,
  c as getEntries
};
//# sourceMappingURL=affstore-ds-types.js.map
